// Constants shared by the User Profile / Security screens. All screen data now comes from the API.

export const SUPPORT_EMAIL = 'support@paybev.us';
